import React from 'react';
import { Clock, Brain, Calendar } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 md:py-16 px-4 bg-gray-50" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        {/* Intro Text */}
        <div className="text-center mb-10" data-id="element-282">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto" data-id="element-283">
            Enseñar Teoría de las Organizaciones{' '}
            <span className="font-bold text-gray-900" data-id="element-284">
              no debería ser una carga mental constante.
            </span>
          </p>
        </div>

        {/* Visual Cards */}
        <div className="grid md:grid-cols-3 gap-4 md:gap-6 mb-8" data-id="element-285">
          <div className="bg-white rounded-xl p-6 shadow-md border border-red-100" data-id="element-286">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-287">
              <Clock className="w-6 h-6 text-red-600" data-id="element-288" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-2 text-center" data-id="element-289">
              Horas de descanso perdidas
            </h3>
            <p className="text-sm text-gray-600 text-center" data-id="element-290">
              Planificando clases hasta tarde en la noche
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md border border-orange-100" data-id="element-291">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-292">
              <Brain className="w-6 h-6 text-orange-600" data-id="element-293" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-2 text-center" data-id="element-294">
              Carga mental constante
            </h3>
            <p className="text-sm text-gray-600 text-center" data-id="element-295">
              Pensando qué enseñar la próxima semana
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md border border-yellow-100" data-id="element-296">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-297">
              <Calendar className="w-6 h-6 text-yellow-600" data-id="element-298" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-2 text-center" data-id="element-299">
              Improvisación semanal
            </h3>
            <p className="text-sm text-gray-600 text-center" data-id="element-300">
              Sin un plan claro para todo el año
            </p>
          </div>
        </div>

        {/* Bottom Text */}
        <div className="text-center" data-id="element-301">
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-302">
            Para muchos docentes,{' '}
            <span className="font-bold text-red-600" data-id="element-303">
              eso es exactamente lo que pasa.
            </span>
          </p>
        </div>
      </div>
    </section>;
}